/**
 * Conversion Success Ticker
 * Handles infinite scroll animation for conversion success cards
 */

(function() {
  'use strict';

  function initTicker(ticker) {
    const track = ticker.querySelector('.conversion-success__track');
    if (!track) return;

    const cards = track.querySelectorAll('.conversion-success__card');
    if (cards.length === 0) return;

    // Clone all cards to create seamless infinite loop
    cards.forEach(card => {
      const clone = card.cloneNode(true);
      track.appendChild(clone);
    });

    // Calculate animation duration based on content width and speed
    const speed = parseInt(ticker.dataset.speed, 10) || 50;
    const trackWidth = track.scrollWidth / 2;
    const duration = trackWidth / speed;

    // Set the CSS custom property for animation duration
    track.style.setProperty('--ticker-duration', `${duration}s`);
  }

  function init() {
    const tickers = document.querySelectorAll('[data-ticker]');
    tickers.forEach(initTicker);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
